import React, { useEffect, useState } from 'react';
import { Card, Collapse } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronCircleDown, faChevronCircleUp
} from '@fortawesome/free-solid-svg-icons';
import Paginator from '../components/Paginator';

function History({action_history}) {

  const ITEMS_PER_PAGE = 10;

  const [showHistory, setShowHistory] = useState(false);
  const [page, setPage] = useState(1);
  const [numPages, setNumPages] = useState(1);

  useEffect(() => {
    setNumPages(Math.ceil(action_history.length / ITEMS_PER_PAGE))
  }, [action_history]);

  return (
    <>
    <p className="phr"/>
    <h2 className="mb-3">History<FontAwesomeIcon icon={faChevronCircleDown} hidden={showHistory} onClick={() => setShowHistory(!showHistory)} className="ms-2" style={{verticalAlign:"middle"}} inverse /><FontAwesomeIcon icon={faChevronCircleUp} hidden={!showHistory} onClick={() => setShowHistory(!showHistory)} className="ms-2" style={{verticalAlign:"middle"}} inverse /></h2>
      <Collapse in={showHistory}>
        <div>
          {action_history.map((action, index) => (
          <Card key={index} className="border rounded d-flex mb-2">
            <Card.Body>
              {action}
            </Card.Body>
          </Card>
          ))}
          <Paginator page={page} numPages={numPages} setPage={setPage} />
        </div>
      </Collapse>
    </>
  );
};

export default History;
